import React, { createContext, useContext, useEffect, useReducer } from 'react';
import { useCookies } from 'react-cookie';
import { useAlert } from 'react-alert';
import { useTranslation } from 'react-i18next';
import createInterceptor from '../../lib/helpers/interceptor';
import fetchMe from '../../lib/fetch/me';
import { initialState, authReducer } from './authReducer';
import { addLog } from '../../lib/fetch/logs';

const AuthContext = createContext([{}, () => {}]);

const AuthProvider = ({ children }) => {
  const { t } = useTranslation('LOGIN');
  const alert = useAlert();

  const [cookies = {}, setCookie, removeCookie] = useCookies([
    'newToken',
    'newIsAdmin',
    'email',
    'newUserType',
  ]);

  // const OLD_DOMAIN_STAG = process.env.REACT_APP_OLD_STAG_COOKIES_DOMAIN || '';
  // const OLD_DOMAIN_PROD = process.env.REACT_APP_OLD_STAG_COOKIES_DOMAIN || '';
  // useEffect(() => {
  //   removeCookie('newToken', { domain: OLD_DOMAIN_STAG });
  //   removeCookie('newIsAdmin', {
  //     domain: OLD_DOMAIN_STAG,
  //   });
  //   removeCookie('email', { domain: OLD_DOMAIN_STAG });
  //   removeCookie('newUserType', {
  //     domain: OLD_DOMAIN_STAG,
  //   });
  //   removeCookie('newToken', { domain: OLD_DOMAIN_PROD });
  //   removeCookie('newIsAdmin', {
  //     domain: OLD_DOMAIN_PROD,
  //   });
  //   removeCookie('email', { domain: OLD_DOMAIN_PROD });
  //   removeCookie('newUserType', {
  //     domain: OLD_DOMAIN_PROD,
  //   });

  //   if (
  //     !cookies.newToken &&
  //     window.location.pathname !== '/login' &&
  //     window.location.pathname !== '/'
  //   ) {
  //     window.location.replace('/');
  //   }
  // }, []);

  const {
    newIsAdmin: isAdminString,
    newToken,
    email,
    newUserType: typeAdmin,
  } = cookies;
  const newIsAdmin = isAdminString ? isAdminString === 'true' : undefined;
  const newUserType = typeAdmin ? typeAdmin : undefined;
  const isAuthenticated = !!(newToken && newToken.length > 0);

  const [state, dispatch] = useReducer(authReducer, {
    ...initialState,
    newToken,
    email,
    newIsAdmin,
    newUserType,
    isAuthenticated,
  });

  const dispatchFunction = (action = {}) => {
    const { type, newToken, newIsAdmin, email, newUserType } = action;

    switch (type) {
      case 'login':
        setCookie('newToken', newToken, {
          maxAge: process.env.REACT_APP_TOKEN_EXPIRATION,
          domain: process.env.REACT_APP_COOKIES_DOMAIN,
        });
        setCookie('newIsAdmin', newIsAdmin, {
          maxAge: process.env.REACT_APP_TOKEN_EXPIRATION,
          domain: process.env.REACT_APP_COOKIES_DOMAIN,
        });
        setCookie('email', email, {
          maxAge: process.env.REACT_APP_TOKEN_EXPIRATION,
          domain: process.env.REACT_APP_COOKIES_DOMAIN,
        });
        setCookie('newUserType', newUserType, {
          maxAge: process.env.REACT_APP_TOKEN_EXPIRATION,
          domain: process.env.REACT_APP_COOKIES_DOMAIN,
        });
        break;
      case 'logout':
        removeCookie('newToken', {
          domain: process.env.REACT_APP_COOKIES_DOMAIN,
        });
        removeCookie('newIsAdmin', {
          domain: process.env.REACT_APP_COOKIES_DOMAIN,
        });
        removeCookie('email', { domain: process.env.REACT_APP_COOKIES_DOMAIN });
        removeCookie('newUserType', {
          domain: process.env.REACT_APP_COOKIES_DOMAIN,
        });
        break;
      default:
        break;
    }

    return dispatch(action);
  };

  useEffect(() => {
    createInterceptor(401, () => dispatch({ type: 'logout' }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const callMe = async () => {
      const { error, data } = await fetchMe(newToken);
      if (error) {
        dispatch({ type: 'logout' });
        alert.error(t('COMMON:GENERIC_ERROR'));
        return;
      }

      if (
        newIsAdmin !== undefined &&
        newToken !== undefined &&
        newUserType !== undefined
      ) {
        const { error: errorLog, data: dataLog } = await addLog(
          { action: 'login', type: 'login' },
          newToken
        );
      }
      dispatch({ type: 'setProfile', profile: data });
    };

    // newIsAdmin has not been set yet. Wait for the next effect.
    if (newIsAdmin === undefined) return;

    if (isAuthenticated) {
      // Admins have no profile
      newIsAdmin ? dispatch({ type: 'setProfile' }) : callMe();

      if (
        newIsAdmin &&
        newIsAdmin !== undefined &&
        newToken !== undefined &&
        newUserType !== undefined
      ) {
        const callLogAdmin = async () => {
          const { error: errorLog, data: dataLog } = await addLog(
            { action: 'login', type: 'login' },
            newToken
          );
        };

        callLogAdmin();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newToken, newIsAdmin, newUserType]);

  return (
    <AuthContext.Provider value={[state, dispatchFunction]}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => useContext(AuthContext);

export { AuthProvider, AuthContext, useAuth };
